module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-product-tab d-flex space-between"
  }, [(_vm.products.length) ? _c('div', {
    class: [_vm.disabledProduct ? 'wrapper-related' : 'wrapper-possibly-like']
  }, [_c('div', {
    staticClass: "possibly-title"
  }, [_vm._v("Posiblemente te gusten:")]), _vm._v(" "), _c('div', {
    class: {
      'card-product-wrapper': _vm.disabledProduct
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('card-product-big', {
      key: product.id,
      class: {
        'card-product': _vm.disabledProduct
      },
      attrs: {
        "product": product,
        "hide-heart": true
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (!_vm.disabledProduct) ? _c('tabs-product', {
    staticClass: "wrapper-tabs",
    class: {
      'width-full': !_vm.products.length
    },
    attrs: {
      "data": _vm.tabs
    },
    on: {
      "select": _vm.selectTab
    }
  }, [(_vm.select) ? _c('div', [(_vm.select.flag === 'questions') ? _c('div', [_c('form-questions', {
    attrs: {
      "id": _vm.id
    },
    on: {
      "update": _vm.updateQuestion
    }
  }), _vm._v(" "), _vm._l((_vm.listQuestions), function(question) {
    return _c('wrapper-answer', {
      key: question.id,
      staticClass: "mb-3",
      attrs: {
        "data": question
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.select.flag === 'opinions') ? _c('div', [_c('wrapper-opinion', {
    attrs: {
      "id": _vm.id,
      "opinions": _vm.listOpinions
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.select.flag === 'service') ? _c('div', _vm._l((_vm.select.subSections), function(subSection) {
    return _c('content-text', {
      key: subSection.id,
      attrs: {
        "content": subSection
      }
    })
  })) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('tabs-product-mobile', {
    staticClass: "wrapper-tabs-mobile",
    attrs: {
      "data": _vm.tabs,
      "list-questions": _vm.listQuestions,
      "opinions": _vm.listOpinions,
      "select": _vm.select
    },
    on: {
      "select": _vm.selectTab
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper-possibly-like-mobile"
  }, [_c('div', {
    staticClass: "possibly-title-mobile txt-center",
    style: (("background-color:" + (_vm.globalColors.primary)))
  }, [_vm._v("POSIBLEMENTE TE GUSTE")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-slider-possibly"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('swiper-slide', {
      key: product.id,
      staticClass: "d-flex"
    }, [_c('card-product-big', {
      attrs: {
        "product": product
      }
    })], 1)
  }))], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20fd4745","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sections/detail/tabs.vue
// module id = 1080
// module chunks = 1